var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidthMinus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.54545 5.60527H15.4545C15.7636 5.60527 16 5.34527 16 5.00527C16 4.66527 15.7636 4.40527 15.4545 4.40527H8.54545C8.23636 4.40527 8 4.66527 8 5.00527C8 5.34527 8.23636 5.60527 8.54545 5.60527Z",
    fill: "#85909F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.219 19.0022C18.9905 19.237 18.9905 19.6087 19.219 19.8239C19.4476 20.0587 19.8095 20.0587 20.019 19.8239L23.8286 15.9109C23.9429 15.7935 24 15.637 24 15.5C24 15.363 23.9429 15.2065 23.8286 15.0891L20.019 11.1761C19.7905 10.9413 19.4286 10.9413 19.219 11.1761C18.9905 11.4109 18.9905 11.7826 19.219 11.9978L22.0571 14.913L1.94286 14.913L4.78095 11.9978C4.89524 11.8804 4.95238 11.7239 4.95238 11.587C4.95238 11.45 4.89524 11.2935 4.78095 11.1761C4.55238 10.9413 4.19048 10.9413 3.98095 11.1761L0.171429 15.0891C-0.0571429 15.3239 -0.0571429 15.6957 0.171429 15.9109L3.98095 19.8239C4.20952 20.0587 4.57143 20.0587 4.78095 19.8239C5.00952 19.5891 5.00952 19.2174 4.78095 19.0022L1.94286 16.087H22.0381L19.219 19.0022Z",
    fill: "#85909F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidthMinus);
export default __webpack_public_path__ + "static/media/widthMinus.e7a3d8cc67cb9f666688be56ab79c577.svg";
export { ForwardRef as ReactComponent };